export type AuthRenderState =
  | "redirect-route"
  | "authenticated"
  | "login"
  | "loading"

type AuthRenderStateArgs = {
  isRedirectRoute: boolean
  isAuthenticatedUser: boolean
  isLoginRoute: boolean
}

export const getAuthRenderState = ({
  isRedirectRoute,
  isAuthenticatedUser,
  isLoginRoute,
}: AuthRenderStateArgs): AuthRenderState => {
  if (isRedirectRoute) return "redirect-route"
  if (isAuthenticatedUser) return "authenticated"
  if (isLoginRoute) return "login"
  return "loading"
}

export const shouldRedirectToLogin = ({
  isLoading,
  isRedirectRoute,
  isAuthenticatedUser,
  isLoginRoute,
}: AuthRenderStateArgs & { isLoading: boolean }): boolean => {
  if (isLoading) return false
  if (isRedirectRoute) return false
  if (isAuthenticatedUser) return false
  if (isLoginRoute) return false
  return true
}

export const shouldRunAuthValidation = ({
  disabled,
  isRouterReady,
  callbackToken,
}: {
  disabled: boolean
  isRouterReady: boolean
  callbackToken?: string | null
}): boolean => {
  if (disabled) return false
  if (!isRouterReady) return false
  if (callbackToken) return false
  return true
}

export const shouldBlockTabSpaceRestore = ({
  savedSpaceUid,
  selectedSpaceUid,
}: {
  savedSpaceUid?: string | null
  selectedSpaceUid?: string | null
}): boolean => {
  if (!savedSpaceUid) return false
  return selectedSpaceUid !== savedSpaceUid
}

export const shouldFinalizeRequestedSpace = ({
  requestedSpaceId,
  selectedSpaceUid,
}: {
  requestedSpaceId?: string | null
  selectedSpaceUid?: string | null
}): boolean => {
  if (!requestedSpaceId) return false
  return selectedSpaceUid === requestedSpaceId
}

export const isClientRouteSpaceNavigation = ({
  routeSpaceReturnUrl,
  clientRouteSpaceReturnUrl,
}: {
  routeSpaceReturnUrl?: string | null
  clientRouteSpaceReturnUrl?: string | null
}): boolean => {
  if (!routeSpaceReturnUrl) return false
  return routeSpaceReturnUrl === clientRouteSpaceReturnUrl
}

export const shouldWaitForRouteSpace = ({
  routeSpaceReturnUrl,
  resolvedRouteSpaceReturnUrl,
  failedRouteSpaceReturnUrl,
  clientRouteSpaceReturnUrl,
}: {
  routeSpaceReturnUrl?: string | null
  resolvedRouteSpaceReturnUrl?: string | null
  failedRouteSpaceReturnUrl?: string | null
  clientRouteSpaceReturnUrl?: string | null
}): boolean => {
  if (!routeSpaceReturnUrl) return false
  if (
    isClientRouteSpaceNavigation({
      routeSpaceReturnUrl,
      clientRouteSpaceReturnUrl,
    })
  ) {
    return false
  }
  if (resolvedRouteSpaceReturnUrl === routeSpaceReturnUrl) return false
  if (failedRouteSpaceReturnUrl === routeSpaceReturnUrl) return false
  return true
}
